import { observable, computed } from "mobx";
import { Entity } from "./Entity";
import { ISystemNotification, SystemNotificationFlags, SystemNotificationDeliveryMethod, ISystemNotificationDelivery } from "../api";
import { AppState } from "../index";

export class SystemNotification extends Entity<ISystemNotification> implements ISystemNotification {
	@observable public id: string;
	@observable public msgKey: string;
	@observable public flags: SystemNotificationFlags;
	@observable public dscid: number;
	@observable public dscaid: number;
	@observable public created: number;
	@observable public deleted: number;

	@observable public sourceName: string;
	@observable public sourceIcon: string;

	@observable public title: string;
	@observable public content: string;

	@observable public htmlContent: string;

	@observable public dsLoader: {
		url: string;
		target: string;
		element: string;
	};

	@observable public firstRead: number;
	@observable public deliveryMethod: SystemNotificationDeliveryMethod;
	@observable public deliveries: ISystemNotificationDelivery[];

	/**
	 * Can this Notification be marked marked as read?
	 */
	public isReadable(): boolean {
		return (this.flags & SystemNotificationFlags.NOT_READABLE) !== 0;
	}
}

export class SystemNotificationStore {
	private store = new Map<string, SystemNotification>();

	constructor(
		private appState: AppState
	) {}

	@computed public get myUnread(): SystemNotification[] {
		let result = [];
		this.store.forEach((value) => {
			if (value.firstRead == null && value.dscaid === this.appState.dscaid) {
				result.push(value);
			}
		});

		return result;
	}

	public set(data: ISystemNotification, { create = true } = {}): SystemNotification {
		let current = this.store.get(data.id);
		if (current == null && create) {
			// not found in store
			current = new SystemNotification();
			this.store.set(data.id, current);
		}

		if (current != null) {
			// update model with new data
			current.assign(data);
		}
		return current;
	}
}



// WEBPACK FOOTER //
// ./src/lib/stores/SystemNotificationStore.ts